import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout'; // Asegúrate que el path sea correcto tras mover cosas
import { authGuard } from './app/core/guards/auth.guard'; // ¡Importante!

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard], // Protegemos toda la estructura interna
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadComponent: () => import('./app/features/dashboard/dashboard.component').then((c) => c.DashboardComponent),
                data: { breadcrumb: 'Dashboard' }
            },
            {
                path: 'calendario/:roomId',
                loadComponent: () => import('./app/features/calendar/calendar.component').then((c) => c.CalendarComponent),
                data: { breadcrumb: 'Calendario' }
            },
            {
                path: 'mis-reservas',
                loadComponent: () => import('./app/features/my-reservations/my-reservations.component').then((c) => c.MyReservationsComponent),
                data: { breadcrumb: 'Mis reservas' }
            },
            {
                path: 'perfil',
                loadComponent: () => import('./app/features/profile/profile.component').then((c) => c.ProfileComponent),
                data: { breadcrumb: 'Perfil' }
            },
            { path: 'notfound', loadComponent: () => import('./app/template-demo/pages/notfound/notfound').then((c) => c.Notfound) },
        ]
    },
    // Rutas públicas (fuera del Layout principal)
    {
        path: 'auth',
        loadChildren: () => import('./app/features/auth/auth.routes') // Tu nueva ruta de auth limpia
    },
    // Mantén esto temporalmente si necesitas consultar la demo en desarrollo
    // {
    //     path: 'demo',
    //     loadChildren: () => import('./app/template-demo/pages/pages.routes')
    // },
    { path: '**', redirectTo: '/notfound' }
];
